/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../controls/controls.module.ts" />

module Meevo.Components.Filters {
    'use strict';

    const InventoryOnHandRuleFilter = (appSettings: Meevo.Components.Common.IAppSettings) => {

        const filter: any = (input: any): number => {
            if (!appSettings.APP_BUSINFOSETTINGS.generalSettings.trackNegativeInventory && input != null && !isNaN(input) && input < 0 ) {
                return 0;
            }
            return input;
        };

        return filter;
    };

    InventoryOnHandRuleFilter.$inject = ['meevo.AppSettings'];

    angular.module('meevo.components.filters')
        .filter('inventoryOnHandRule', InventoryOnHandRuleFilter);

}